<template>
    <a href="https://www.gestoraion.com" target="_blank" rel="noopener noreferrer">
        <div class="powered-by">
            powered by <span>AION</span>
        </div>
    </a>
</template>

<script>
export default {
    name: 'powered-by'
};
</script>

<style lang="scss" scoped>
a,
a:hover,
a:visited,
a:active {
    text-decoration: none;
    color: #5e686c;
}

.powered-by {
    text-align: right;
    font-size: 14px;
    margin-right: -5px;
    color: #5e686c;

    span {
        text-decoration: none;
        color: #fec02f;
    }
}
</style>
